import React from 'react';
import './Benefits.css';

const Benefits: React.FC = () => {
    const benefits = [
        {
            title: "Save Valuable Time",
            description: "Reduce email processing time by up to 70% with smart, categorized summaries.",
            icon: "⏱️"
        },
        {
            title: "Never Miss Important Emails",
            description: "Stay on top of follow-ups, approvals, and payment reminders with organized digests.",
            icon: "🎯"
        },
        {
            title: "Boost Productivity",
            description: "Focus on what matters by eliminating constant inbox monitoring.",
            icon: "📈"
        },
        {
            title: "Reduce Email Stress",
            description: "Experience inbox peace of mind with automated email management.",
            icon: "🧘‍♀️"
        }
    ];

    return (
        <section className="benefits" id="benefits">
            <div className="container">
                <h2>Why Choose MailMeld?</h2>
                <div className="benefits-grid">
                    {benefits.map((benefit, index) => (
                        <div key={index} className="benefit-card animate-fadeIn">
                            <div className="benefit-icon-wrapper">
                                <span className="benefit-icon">{benefit.icon}</span>
                            </div>
                            <div className="benefit-content">
                                <h3>{benefit.title}</h3>
                                <p>{benefit.description}</p>
                            </div>
                            <div className="benefit-background"></div>
                        </div>
                    ))}
                </div>
                <div className="testimonial animate-fadeIn">
                    <blockquote>
                        "MailMeld has transformed how I handle my emails. I'm saving hours each week and never miss important follow-ups!"
                    </blockquote>
                    <cite>- Sarah Chen, Product Manager</cite>
                </div>
            </div>
        </section>
    );
};

export default Benefits;